import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=dca1ec26&scoped=true&"
import script from "./TaskStatus.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TaskStatus.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TaskStatus.vue?vue&type=style&index=0&id=dca1ec26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca1ec26",
  null
  
)

export default component.exports